import BaseView from './BaseView';
import SimpleBar from 'simplebar';
import 'simplebar/dist/simplebar.css';

let view = null;

class Index extends BaseView {
	constructor(container) {
		super(container);
	}

	init() {
		this.breakpoint = window.matchMedia('(min-width:992px)');
		this.simpleBars = [];

		// Tabs
		this.container.querySelectorAll('[data-index-tabs]').forEach((tabs) => {
			const buttons = tabs.querySelectorAll('[data-index-tab]');
			const targets = Array.from(buttons).map((button) => this.container.querySelector(button.dataset.indexTab));

			tabs.addEventListener('click', (e) => {
				const clickedButton = e?.target?.closest('[data-index-tab]');

				if (!clickedButton) {
					return;
				}

				window.scrollTo(0, -1);

				// Activate button
				buttons.forEach((button) => {
					if (button === clickedButton) {
						button.classList.add('is-active');
						button.setAttribute('aria-expanded', true);
					} else {
						button.classList.remove('is-active');
						button.setAttribute('aria-expanded', false);
					}
				});

				// Activate content
				targets.forEach((target) => {
					if (target.matches(clickedButton.dataset.indexTab)) {
						target.classList.add('is-active');
					} else {
						target.classList.remove('is-active');
					}
				});
			});
		});

		// Companies and glossary hover effect
		const breakpoint = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width:992px)');

		const glossaryElement = this.container.querySelector('[data-glossary]');
		const companiesElement = this.container.querySelector('[data-companies]');

		glossaryElement.addEventListener('mouseenter', (e) => {
			if (!breakpoint.matches) {
				return;
			}

			companiesElement.classList.add('is-dimmed');
		});

		glossaryElement.addEventListener('mouseleave', (e) => {
			if (!breakpoint.matches) {
				return;
			}

			companiesElement.classList.remove('is-dimmed');
		});

		// Custom scrollbars
		if (this.breakpoint.matches) {
			this.simpleBars.push(new SimpleBar(this.container.querySelector('.c-companies__companies')));
			this.simpleBars.push(new SimpleBar(this.container.querySelector('.c-glossary__items')));
		}

		this.container.addEventListener('collapse-opened', (e) => {
			this.recalculateSimpleBars();
		});

		this.container.addEventListener('collapse-closed', (e) => {
			this.recalculateSimpleBars();
		});
	}

	recalculateSimpleBars() {
		this.simpleBars.forEach((simpleBar) => simpleBar.recalculate());
	}
}

export default {
	namespace: 'template-index',
	beforeEnter: ({ current, next, trigger }) => {
		view = new Index(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
